export class CmsAdvancedPageModel {
 public id!: string;
 public loadTimestamp!: any;
 public page_id!: number;
 public containers!: any;
 public metaKeywords!: any;
 public metaDescription!: any;
 
 
 //cloud 接口参数
 public activitySubscribeId!: string;
 public autoPublish: any;
 public content: any;
 public enableLike: number = 0;
 public enableLinkage: any = 0;
 public enableShare: any = 1;
 public enableSubscribeMessage: any = 0;
 public identifier: any;
 public isActive: any = 1;
 public merchantId:any = '100000005';
 public preview: any;
 
 public showTitle: any = 1;
 public sortOrder: any = 0;
 public storeId: any= 10;
 
 public title: any;
 public type: any = 'cms';
 public addition: any = {"homeEntrance":0,"throughTop":0,"endTime":""};
 public startTime:any;//界面显示时间
 

  constructor(data: {}) {
    Object.assign(<CmsAdvancedPageModel>this, data);
  }

  public getHtml(data: any){
    return data[0][0].html;
  }

  public jsonDecodeContainers() {
    let htmlInfo;
    htmlInfo = JSON.parse(this.containers);
    return htmlInfo;
  }
}
